<template>
  <el-tooltip class="item" effect="dark" placement="top-start" :content="title">
    <img :src="img" :alt="title" />
  </el-tooltip>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import key from '@/apps/traforama/assets/icons/key.png'
import handshake from '@/apps/traforama/assets/icons/handshake.png'
export default defineComponent({
  name: 'AvailabilityLabel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const title = computed(() => {
      return props.modelValue ? 'Available' : 'On request'
    })
    const img = computed(() => {
      return props.modelValue ? handshake : key
    })
    return { title, img }
  }
})
</script>

<style lang="scss" scoped>
img {
  width: 30px;
}
</style>
